import React from 'react';
import './App.css';

function App() {
  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <h1 style={styles.title}>Privacy Policy for 我不是哥布林</h1>
        <p style={styles.subtitle}>Last updated: March 25, 2025</p>
      </header>

      <main style={styles.main}>
        <section style={styles.section}>
          <h2>Privacy Policy</h2>
          <p>
            This Privacy Policy describes Our policies and procedures on the
            collection, use and disclosure of Your information when You use the
            Service and tells You about Your privacy rights and how the law
            protects You.
          </p>
          <p>
            We use Your Personal data to provide and improve the Service. By
            using the Service, You agree to the collection and use of
            information in accordance with this Privacy Policy. This Privacy
            Policy has been created with the help of a Privacy Policy Generator.
          </p>
        </section>

        <section style={styles.section}>
          <h2>Interpretation and Definitions</h2>
          <h3>Interpretation</h3>
          <p>
            The words of which the initial letter is capitalized have meanings
            defined under the following conditions. The following definitions
            shall have the same meaning regardless of whether they appear in
            singular or in plural.
          </p>

          <h3>Definitions</h3>
          <p>
            For the purposes of this Privacy Policy:
            <ul style={styles.ul}>
              <li>
                <strong>Account</strong> means a unique account created for You
                to access our Service or parts of our Service.
              </li>
              <li>
                <strong>Affiliate</strong> means an entity that controls, is
                controlled by or is under common control with a party, where
                &quot;control&quot; means ownership of 50% or more of the
                shares, equity interest or other securities entitled to vote for
                election of directors or other managing authority.
              </li>
              <li>
                <strong>Application</strong> refers to 我不是哥布林, the software
                program provided by the Company.
              </li>
              <li>
                <strong>Company</strong> (referred to as either &quot;the
                Company&quot;, &quot;We&quot;, &quot;Us&quot; or &quot;Our&quot;
                in this Agreement) refers to 我不是哥布林.
              </li>
              <li>
                <strong>Country</strong> refers to: Taiwan
              </li>
              <li>
                <strong>Device</strong> means any device that can access the
                Service such as a computer, a cellphone or a digital tablet.
              </li>
              <li>
                <strong>Personal Data</strong> is any information that relates to
                an identified or identifiable individual.
              </li>
              <li>
                <strong>Service</strong> refers to the Application.
              </li>
              <li>
                <strong>Service Provider</strong> means any natural or legal
                person who processes the data on behalf of the Company.
              </li>
              <li>
                <strong>Usage Data</strong> refers to data collected
                automatically, either generated by the use of the Service or
                from the Service infrastructure itself (for example, the
                duration of a page visit).
              </li>
              <li>
                <strong>You</strong> means the individual accessing or using the
                Service, or the company, or other legal entity on behalf of
                which such individual is accessing or using the Service, as
                applicable.
              </li>
            </ul>
          </p>
        </section>

        <section style={styles.section}>
          <h2>Collecting and Using Your Personal Data</h2>
          <h3>Types of Data Collected</h3>
          <h4>Personal Data</h4>
          <p>
            While using Our Service, We may ask You to provide Us with certain
            personally identifiable information that can be used to contact or
            identify You. Personally identifiable information may include, but
            is not limited to:
          </p>

          <h4>Usage Data</h4>
          <p>
            Usage Data is collected automatically when using the Service. Usage
            Data may include information such as Your Device&apos;s Internet
            Protocol address (e.g. IP address), browser type, browser version,
            the pages of our Service that You visit, the time and date of Your
            visit, the time spent on those pages, unique device identifiers and
            other diagnostic data.
          </p>
          <p>
            When You access the Service by or through a mobile device, We may
            collect certain information automatically, including, but not
            limited to, the type of mobile device You use, Your mobile device
            unique ID, the IP address of Your mobile device, Your mobile
            operating system, the type of mobile Internet browser You use,
            unique device identifiers and other diagnostic data.
          </p>
          <p>
            We may also collect information that Your browser sends whenever You
            visit our Service or when You access the Service by or through a
            mobile device.
          </p>

          <h4>Information Collected while Using the Application</h4>
          <p>
            While using Our Application, in order to provide features of Our
            Application, We may collect, with Your prior permission:
          </p>
          <ul style={styles.ul}>
            <li>
              Pictures and other information from your Device&apos;s camera and
              photo library
            </li>
          </ul>
          <p>
            We use this information to provide features of Our Service, to
            improve and customize Our Service. The information may be uploaded
            to the Company&apos;s servers and/or a Service Provider&apos;s
            server or it may be simply stored on Your device.
          </p>
          <p>
            You can enable or disable access to this information at any time,
            through Your Device settings.
          </p>

          {/* ### 新增：臉部資料 (Face Data) 和第三方分析服務的說明 */}
          <h4>Face Data and Third-Party Services</h4>
          <p>
            If our Application implements facial detection or recognition
            features (for instance, applying filters or generating a &quot;Goblin
            Index&quot;), We may process face data solely for the purpose of
            real-time analysis. We do not permanently store or retain any face
            images or derived facial feature data on Our servers.
          </p>
          <p>
            <strong>No Retention of Face Data:</strong> All facial images used
            for analysis are either processed locally on Your device or briefly
            transmitted to a third-party service for immediate detection. Once
            the analysis is complete, We do not keep any face data. If You
            disable camera permissions, We will not collect or process face
            data.
          </p>
          <p>
            <strong>Third-Party Analysis (e.g., Google ML Kit):</strong> In some
            cases, We may use external services—such as Google ML Kit—to perform
            face detection or analysis. These services may receive the necessary
            image data momentarily and discard it once the process concludes. We
            encourage You to review{' '}
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google&apos;s Privacy Policy
            </a>{' '}
            or any applicable third-party privacy statements. We ensure such
            providers only process face data as required for detection and do
            not retain it beyond that purpose.
          </p>

        </section>

        <section style={styles.section}>
          <h3>Use of Your Personal Data</h3>
          <p>
            The Company may use Personal Data for the following purposes:
          </p>
          <ul style={styles.ul}>
            <li>
              <strong>To provide and maintain our Service</strong>, including to
              monitor the usage of our Service.
            </li>
            <li>
              <strong>To manage Your Account:</strong> to manage Your
              registration as a user of the Service. The Personal Data You
              provide can give You access to different functionalities of the
              Service that are available to You as a registered user.
            </li>
            <li>
              <strong>For the performance of a contract:</strong> the
              development, compliance and undertaking of the purchase contract
              for the products, items or services You have purchased or of any
              other contract with Us through the Service.
            </li>
            <li>
              <strong>To contact You:</strong> To contact You by email,
              telephone calls, SMS, or other equivalent forms of electronic
              communication, such as a mobile application&apos;s push
              notifications.
            </li>
            <li>
              <strong>To provide You with news, special offers</strong> and
              general information about other goods, services and events which
              we offer, unless You have opted not to receive such information.
            </li>
            <li>
              <strong>To manage Your requests:</strong> To attend and manage
              Your requests to Us.
            </li>
            <li>
              <strong>For business transfers:</strong> We may use Your
              information to evaluate or conduct a merger, divestiture,
              restructuring, reorganization, dissolution, or other sale or
              transfer of some or all of Our assets.
            </li>
            <li>
              <strong>For other purposes:</strong> data analysis, identifying
              usage trends, determining the effectiveness of our promotional
              campaigns, evaluating and improving Our Service.
            </li>
          </ul>

          <p>
            <strong>We may share Your personal information</strong> in the
            following situations:
          </p>
          <ul style={styles.ul}>
            <li>
              <strong>With Service Providers:</strong> We may share Your
              personal information with Service Providers to monitor and analyze
              the use of our Service, or to contact You.
            </li>
            <li>
              <strong>For business transfers:</strong> We may share or transfer
              Your personal information in connection with, or during
              negotiations of, any merger, sale, or acquisition.
            </li>
            <li>
              <strong>With Affiliates:</strong> We may share Your information
              with Our affiliates, provided they honor this Privacy Policy.
            </li>
            <li>
              <strong>With business partners:</strong> To offer You certain
              products, services or promotions.
            </li>
            <li>
              <strong>With other users:</strong> when You share personal
              information or otherwise interact in public areas with other
              users, such information may be viewed by all users.
            </li>
            <li>
              <strong>With Your consent:</strong> We may disclose Your personal
              information for any other purpose with Your consent.
            </li>
          </ul>
        </section>

        <section style={styles.section}>
          <h3>Retention of Your Personal Data</h3>
          <p>
            The Company will retain Your Personal Data only for as long as is
            necessary for the purposes set out in this Privacy Policy. We will
            retain and use Your Personal Data to the extent necessary to comply
            with our legal obligations, resolve disputes, and enforce our legal
            agreements and policies.
          </p>
          <p>
            The Company will also retain Usage Data for internal analysis
            purposes. Usage Data is generally retained for a shorter period,
            unless used to strengthen security or improve functionality of Our
            Service, or We are legally obligated to retain it for longer.
          </p>
        </section>

        <section style={styles.section}>
          <h3>Transfer of Your Personal Data</h3>
          <p>
            Your information, including Personal Data, may be processed at the
            Company&apos;s operating offices and in any other places involved in
            the processing. It means the data may be transferred and maintained
            on computers located outside of Your state or country where data
            protection laws may differ.
          </p>
          <p>
            By using our Service, You consent to such transfer. The Company will
            ensure no transfer occurs to an organization or country lacking
            adequate security controls for personal information.
          </p>
        </section>

        <section style={styles.section}>
          <h3>Delete Your Personal Data</h3>
          <p>
            You have the right to delete or request assistance in deleting the
            Personal Data collected about You. Our Service may allow You to
            delete certain information from within the Service. You may also
            request access, correction, or deletion of any personal data You
            provided to Us. We may retain some data if we have a legal
            obligation or lawful basis to do so.
          </p>
        </section>

        <section style={styles.section}>
          <h3>Disclosure of Your Personal Data</h3>
          <h4>Business Transactions</h4>
          <p>
            If the Company is involved in a merger, acquisition or asset sale,
            Your Personal Data may be transferred. We will provide notice before
            it becomes subject to a different Privacy Policy.
          </p>

          <h4>Law Enforcement</h4>
          <p>
            Under certain circumstances, the Company may be required to disclose
            Your Personal Data by law or in response to valid requests by public
            authorities.
          </p>

          <h4>Other Legal Requirements</h4>
          <p>
            The Company may disclose Your Personal Data in the good faith belief
            that such action is necessary to:
          </p>
          <ul style={styles.ul}>
            <li>Comply with a legal obligation</li>
            <li>Protect and defend the rights or property of the Company</li>
            <li>
              Prevent or investigate possible wrongdoing in connection with the
              Service
            </li>
            <li>
              Protect the personal safety of Users of the Service or the public
            </li>
            <li>Protect against legal liability</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h3>Security of Your Personal Data</h3>
          <p>
            We strive to use commercially acceptable means to protect Your
            Personal Data, but no method of transmission over the Internet or
            electronic storage is 100% secure. We cannot guarantee its absolute
            security.
          </p>
        </section>

        <section style={styles.section}>
          <h3>Children&apos;s Privacy</h3>
          <p>
            Our Service does not address anyone under the age of 13. We do not
            knowingly collect personally identifiable information from anyone
            under 13. If You are a parent or guardian and become aware that Your
            child has provided Us with Personal Data, please contact Us. If We
            discover a child under 13 has provided Personal Data without
            parental consent, we will remove it from Our servers.
          </p>
        </section>

        <section style={styles.section}>
          <h3>Links to Other Websites</h3>
          <p>
            Our Service may contain links to other websites not operated by Us.
            If You click a third-party link, You will be directed to their site.
            We strongly advise You to review the Privacy Policy of every site
            you visit. We assume no responsibility for the content or practices
            of any third-party sites.
          </p>
        </section>

        <section style={styles.section}>
          <h3>Changes to this Privacy Policy</h3>
          <p>
            We may update Our Privacy Policy from time to time. We will notify
            You of any changes by posting the new Privacy Policy on this page
            and updating the &quot;Last updated&quot; date above. You are
            advised to review this Privacy Policy periodically for any changes.
          </p>
        </section>

        <section style={styles.section}>
          <h3>Contact Us</h3>
          <p>
            If you have any questions about this Privacy Policy, You can contact
            us:<br />
            By email:{' '}
            <a href="mailto:stony870129@gmail.com">stony870129@gmail.com</a>
          </p>
          <p>Generated using Privacy Policies Generator</p>
        </section>
      </main>

      <footer style={styles.footer}>
        © 2025 我不是哥布林. All rights reserved.
      </footer>
    </div>
  );
}

export default App;

const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#f8f9fa',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    backgroundColor: '#007bff',
    padding: '1rem',
    textAlign: 'center',
    color: '#fff',
  },
  title: {
    margin: 0,
    fontSize: '1.8rem',
  },
  subtitle: {
    margin: 0,
    fontSize: '0.9rem',
    fontStyle: 'italic',
  },
  main: {
    flex: 1,
    maxWidth: '800px',
    margin: '0 auto',
    padding: '1rem',
  },
  section: {
    backgroundColor: '#fff',
    padding: '1rem',
    marginBottom: '1rem',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  ul: {
    marginLeft: '1.5rem',
  },
  footer: {
    textAlign: 'center',
    padding: '0.5rem',
    backgroundColor: '#e9ecef',
  },
};
